export default "__VITE_ASSET__6f087d25__"